
  import firebase from "firebase"
  import firestore from "firebase/firestore"
 // Initialize Firebase
  var config = {
    apiKey: "AIzaSyAvwgCQ1U_t5hq7sFnSCBFS1GwVNTydLco",
    authDomain: "whereabouts-2e7f9.firebaseapp.com",
    databaseURL: "https://whereabouts-2e7f9.firebaseio.com",
    projectId: "whereabouts-2e7f9",
    storageBucket: "whereabouts-2e7f9.appspot.com",
    messagingSenderId: "663386186004"
  };
  const firebaseApp = firebase.initializeApp(config);
  firebaseApp.firestore().settings({timestampsInSnapshots:true})
  var storage = firebase.storage();
  export default firebaseApp.firestore()

    // Get a reference to the storage service, which is used to create references in your storage bucket
    


// WEBPACK FOOTER //
// ./src/firebase/init.js